import React from 'react'
import './LiveDiscuss.css'
import Axios from 'axios'
import NettyClient from '../UserChat/sdk/sdk';

/**
 * Emoji组件
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Emoji = (props) => {
    const emoji = [
        {
            groupname: '',
            group: [
                '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😇',
                '😉', '😊', '🙂', '🙃', '😋', '😌', '😍', '🥰', '😘',
                '😗', '😙', '😚', '🤪', '😜', '😝', '😛', '🤑', '😎',
                '🤓', '🧐', '🤠', '🥳', '🤗', '🤡', '😏', '😶', '😐',
                '😑', '😒', '🙄', '🤨', '🤔', '🤫', '🤭', '🤥', '😳',
                '😞', '😟', '😠', '😡', '🤬', '😔', '😕', '🙁', '😬',
                '🥺', '😣', '😖', '😫', '😩', '🥱', '😤', '😮', '😱',
                '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '🤤',
                '😓', '😭', '🤩', '😵', '🥴', '😲', '🤯', '🤐', '😷',
                '🤕', '🤒', '🤮', '🤢', '🤧', '🥵', '🥶', '😴', '💤',
                '😈', '👹', '👺']
        }]

    function insertEmoji(char) {
        let textarea = document.getElementById('discuss_textarea');
        let textareaStr = textarea.value;
        let start = textarea.selectionStart;//文本的起始位置
        let end = textarea.selectionEnd;//文本的结束位置
        if (!textareaStr) textareaStr = '';
        let str = textareaStr.substring(0, start) + char + textareaStr.substring(end)
        props.setvalue(str)

        // props.close()
        textarea.focus()
        // textarea.selectionStart=start
    }
    return (
        <div className='liveDiscuss-emoji-back'>
            {
                emoji[0].group.map((char, index) => {
                    return (
                        <div className='emoji' key={index} style={{ float: 'left', cursor: 'pointer' }} onClick={insertEmoji.bind(this, char)}>
                            {char}
                        </div>
                    )
                })
            }
        </div>
    )
}

export default class LiveDiscuss extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            userId: props.userId,
            userName: props.userName,

            liveId: props.liveId,
            pullPath: props.pullPath,
            liveName: props.liveName,//直播间名称
            liveCover: props.liveCover,//直播间封面
            hostId: props.hostId,
            liveNotice: props.liveNotice,
            groupId: props.groupId,

            editorContent: "",
            data: [],
            onLineClient: [],

            isLoaded: false,
            liveStatus: props.liveStatus,//当前是否处于直播状态
            left: true, //控制显示区域
            emoji: false,//是否显示emoji
        }
        this.imageRef = React.createRef();
        this.fileRef = React.createRef();
    }

    async componentWillMount() {
        const { userId, userName,
            liveId, pullPath, liveName, liveCover, hostId, liveNotice, groupId,
            liveStatus } = this.state;

        if (groupId !== "") {
            await this.initNettyClient(userId, groupId);
            if (userId !== hostId) {//如果用户不是群主,将用户加入群组
                await this.saveMember(groupId, userId);
            }
        }
        this.setState({ isLoaded: true });
    }

    async componentDidMount() {
        let list = await this.getMemberList(this.state.groupId)
        this.setState({
            onLineClient: list
        })
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.groupId !== this.state.groupId) {
            const { userId, userName,
                liveId, pullPath, liveName, liveCover, hostId, liveNotice, groupId,
                liveStatus } = this.props;
            await this.setState({
                userId: userId, userName: userName,
                liveId: liveId, pullPath: pullPath, liveName: liveName, liveCover: liveCover, hostId: hostId, liveNotice: liveNotice, groupId: groupId,
                liveStatus: liveStatus
            });//保存新的groupId

            await this.initNettyClient(userId, groupId);
            if (userId !== hostId) {//如果用户不是群主,将用户加入群组
                await this.saveMember(groupId, userId);
            }
        }
    }

    /**
     * 建立websocket连接
     * @param userId  用户ID
     * @param groupId 群号
     */
    initNettyClient = (userId, groupId) => {
        //新建NettyClient客户端，连接到imServer
        this.client = new NettyClient({ url: global.support.imServer });
        //绑定用户身份
        this.client.connect({ userId: userId, userType: "Servicer" });
        //订阅直播间,收到消息会触发回调函数,渲染聊天室数据
        this.client.subscribe("/group/" + groupId, msg => {
            let data = { content: msg.content, contentType: msg.contentType, userId: msg.sender };
            this.setState({ data: [...this.state.data, data] }, () => {
                if (document.getElementById("msg_end"))
                    document.getElementById("msg_end").scrollIntoView();//自动滚动到最底部消息
            });//重新渲染数据
        });
    }

    /**
     * 添加群组成员
     * @param groupId
     * @param userId
     * @returns {Promise<void>}
     */
    saveMember = async (groupId, userId) => {
        const apiRoot = `${global.url.im}/group/${groupId}/member/save`;
        const data = {};
        data.groupId = groupId;
        data.userId = userId;
        await Axios.post(apiRoot, data);
    }

    /**
     * 获取群成员，以及其详细信息
     * @param groupId
     * @returns {Promise<*>}
     */
    getMemberList = async (groupId) => {
        const apiRoot = `${global.url.im}/group/${groupId}/member/info`;
        let data;
        await Axios.get(apiRoot).then(res => {
            data = res.data.payload;
        });
        return data;
    }

    /**
     * 发送图片信息
     */
    handleSubmitImage = () => {
        let data = new FormData();
        data.append("file", this.imageRef.current.files[0]);

        const apiRoot = `${global.support.ossUpload}/oss/upload`;
        Axios.post(apiRoot, data)
            .then(res => {
                let fileUrl = `${window.serviceUrl.fileServerImg}` + res.data.payload;//图片存储的地址

                try {
                    //发送群聊消息，topic必须写"/group/"+直播间id的形式，content应该是json,content可填可不填
                    this.client.publish("/group/" + this.state.groupId, { content: fileUrl, userName: this.state.userName }, 'img').then(res => {
                        // debugger
                        console.log('群发消息成功');
                        this.setState({
                            editorContent: ""
                        })
                    }).catch(res => {
                        console.log('消息发送失败')
                    })
                } catch (e) {
                    console.log("发送消息失败,原因是" + JSON.stringify(e))
                }

            });
    }

    /**
     * 发送文件
     */
    handleSubmitFile = () => {
        let data = new FormData();
        let filesize = "";
        data.append("file", this.fileRef.current.files[0]);

        // console.log("文件名："+this.fileRef.current.files[0].name);//文件名
        //这段代码是单位的换算，是B、KB、MB的单位
        if (this.fileRef.current.files[0].size < 1024) {
            filesize = this.fileRef.current.files[0].size + 'B';
        } else {
            if (this.fileRef.current.files[0].size < 1024 * 1024) {
                filesize = ((this.fileRef.current.files[0].size) / 1024).toFixed(2) + 'KB';
            } else {
                filesize = ((this.fileRef.current.files[0].size) / 1024 / 1024).toFixed(2) + 'MB';
            }
        }

        const apiRoot = `${global.support.ossUpload}/oss/upload`;
        Axios.post(apiRoot, data)
            .then(res => {
                let fileUrl = `${window.serviceUrl.fileServer}` + '/' + res.data.payload;//文件存储的地址

                try {
                    //发送群聊消息，topic必须写"/group/"+直播间id的形式，content应该是json,content可填可不填
                    this.client.publish("/group/" + this.state.groupId, { content: fileUrl, fileName: this.fileRef.current.files[0].name, fileSize: filesize, userName: this.state.userName }, 'file').then(res => {
                        // debugger
                        console.log('群发消息成功');
                        this.setState({
                            editorContent: ""
                        })
                    }).catch(res => {
                        console.log('消息发送失败')
                    })
                } catch (e) {
                    console.log("发送消息失败,原因是" + JSON.stringify(e))
                }

            });
    }

    /**
     * 发送文本信息
     * @returns {Promise<void>}
     */
    handleSubmitText = async () => {
        if (this.state.editorContent === "") {
            return;
        }

        try {
            //发送群聊消息，topic必须写"/group/"+直播间id的形式，content应该是json,content可填可不填
            this.client.publish("/group/" + this.state.groupId, { content: this.state.editorContent, userName: this.state.userName }, 'text').then(res => {
                // debugger
                console.log('群发消息成功');
                this.setState({
                    editorContent: ""
                })
            }).catch(res => {
                console.log('消息发送失败')
            })
        } catch (e) {
            console.log("发送消息失败,原因是" + JSON.stringify(e))
        }
    }

    /**
     * 渲染消息
     * @param data
     * @returns {JSX.Element}
     */
    renderChatRecord = (data) => {
        const chatInfo = data;
        const chatlist = chatInfo.map((item, index) => {
            //如果不是用户发的信息
            if (item.userId != this.state.userId) {
                return (
                    <div className="live-manager-layout-right-content-item1" key={index}>
                        <div className="live-manager-layout-right-content-item-name">
                            {item.content.userName}
                        </div>
                        {item.contentType === "text" && <React.Fragment>
                            <div className="live-manager-layout-right-content-item-content-message-line">
                                <div className="live-manager-layout-right-content-item-content-message">
                                    {item.content.content}
                                </div></div>
                        </React.Fragment>}
                        {item.contentType === "img" && <React.Fragment>
                            <a target="_blank" href={item.content.content} download>
                                <div className="live-manager-layout-right-content-item-content-img" style={{ background: `url(${item.content.content})`, backgroundSize: 'cover' }} />
                            </a>
                        </React.Fragment>}
                        {item.contentType === "file" && <React.Fragment>
                            <div className="live-manager-layout-right-content-item-content-file" onClick={() => { }}>
                                <div className="live-manager-layout-right-content-item-content-file-name">
                                    <p>{item.content.fileName}</p>
                                    <p>{item.content.fileSize}</p>
                                </div>
                                <a target="_blank" href={item.content.content} download={item.content.fileName}>
                                    <img style={{ width: 51.88, height: 60.49 }} src={require('./img/icon-word.png')} />
                                </a>
                            </div>
                        </React.Fragment>}
                    </div>
                )
            }
            //如果是用户发的信息
            else {
                return (
                    <div className="live-manager-layout-right-content-item2" key={index}>
                        {item.contentType === "text" && <React.Fragment>
                            <div className="live-manager-layout-right-content-item-reverse-message">
                                {item.content.content}
                            </div>
                        </React.Fragment>}
                        {item.contentType === "img" && <React.Fragment>
                            <a target="_blank" href={item.content.content} download>
                                <div className="live-manager-layout-right-content-item-reverse-img" style={{ background: `url(${item.content.content})`, backgroundSize: 'cover' }} />
                            </a>
                        </React.Fragment>}
                        {item.contentType === "file" && <React.Fragment>
                            <div className="live-manager-layout-right-content-item-reverse-file">
                                <div className="live-manager-layout-right-content-item-content-file-name">
                                    <p>{item.content.fileName}</p>
                                    <p>{item.content.fileSize}</p>
                                </div>
                                <a target="_blank" href={item.content.content} download={item.content.fileName}>
                                    <img style={{ width: 51.88, height: 60.49 }} src={require('./img/icon-word.png')} />
                                </a>
                            </div>
                        </React.Fragment>}
                    </div>
                )
            }
        });
        return (<React.Fragment>{chatlist}</React.Fragment>);
    }

    /**
     * 渲染在线人数列表
     * @param data 在线人数列表的数据
     * @returns {JSX.Element}
     */
    renderOnlineUser = (data) => {
        const userInfo = data;
        const userlist = userInfo.map((user) =>
            <li className="userItem" key={user.userId.toString()}>
                <div className="userIcon" style={{ background: `url(${user.account.avatar}) no-repeat`, backgroundSize: 'cover' }} />
                <div className="userName">{user.account.userName}</div>
            </li>);
        return (<ul>{userlist}</ul>);
    }

    render() {
        const { userId, userName,
            liveId, pullPath, liveName, liveCover, hostId, liveNotice, groupId,
            editorContent, data, onLineClient,
            liveStatus, isLoaded, left, emoji } = this.state

        if (!isLoaded) {
            return (<React.Fragment />)
        }
        if (liveStatus) {
            return (<React.Fragment>{/*如果已经开始直播*/}
                {/*标题*/}
                <div className="live-manager-layout-right-header2">
                    <div className="live-manager-layout-right-header2-button" onClick={() => this.setState({ left: true })}>
                        讨论
                    </div>
                    {/* <div className="live-manager-layout-right-header2-button"
                        onClick={async () => {
                            let list = await this.getMemberList(groupId);
                            await this.setState({ left: false, onLineClient: list });
                        }}>
                        在线人数{onLineClient.length}
                    </div> */}
                </div>
                {left && <React.Fragment>
                    {/*内容*/}
                    <div className="live-manager-layout-right-content">
                        {this.renderChatRecord(data)}
                        <div id="msg_end" />
                    </div>
                    {/*底部*/}
                    <div className="live-manager-layout-right-footer">
                        {/*emoji表情 close={() => {this.emoji.close()}} */}
                        {
                            emoji && <React.Fragment>
                                <Emoji id="emoji" setvalue={(str) => { this.setState({ editorContent: str, emoji: !emoji }) }} />
                            </React.Fragment>
                        }
                        {/*工具栏*/}
                        <div className="live-manager-layout-right-footer-toolbar">
                            {/*上传图片*/}
                            {/* <div className="live-manager-layout-right-footer-toolbar-btn">
                                <span className="live-manager-layout-right-footer-toolbar-pic">
                                    <input type="file" accept="image/*" ref={this.imageRef} onChange={this.handleSubmitImage} />
                                </span>
                            </div> */}
                            {/*emoji表情包*/}
                            <div className="live-manager-layout-right-footer-toolbar-btn">
                                <span className="live-manager-layout-right-footer-toolbar-face" onClick={() => { this.setState({ emoji: !emoji }) }}>
                                    {/*<input type="file" />*/}
                                </span>
                            </div>
                            {/*上传文件*/}
                            <div className="live-manager-layout-right-footer-toolbar-btn">
                                <span className="live-manager-layout-right-footer-toolbar-history">
                                    <input type="file" ref={this.fileRef} onChange={this.handleSubmitFile} />
                                </span>
                            </div>
                            {/*/!*设置*!/*/}
                            {/*<div className="live-manager-layout-right-footer-toolbar-btn">*/}
                            {/*    <span className="live-manager-layout-right-footer-toolbar-set">*/}
                            {/*        <input type="file" />*/}
                            {/*    </span>*/}
                            {/*</div>*/}
                        </div>
                        {/*输入框*/}
                        <div className="live-manager-layout-right-footer-editor">
                            <textarea id="discuss_textarea" value={editorContent} onChange={(e) => {
                                this.setState({
                                    editorContent: e.target.value
                                })
                            }} />
                        </div>
                        {/*发送*/}
                        <div className="live-manager-layout-right-footer-submit">
                            <div className="live-manager-layout-right-footer-submit-btn" onClick={this.handleSubmitText}>
                                发送
                            </div>
                        </div>
                    </div>
                </React.Fragment>}
                {!left && <React.Fragment>
                    {/*在线人数列表*/}
                    <div className="live-manager-layout-right-content2">
                        {
                            this.renderOnlineUser(onLineClient)
                        }
                    </div>
                </React.Fragment>}
            </React.Fragment>)
        }
        if (!liveStatus) {
            return (<React.Fragment>{/*如果没有开始直播*/}
                {/*标题*/}
                <div className="live-manager-layout-right-header">
                    讨论区
                </div>
                {/*内容*/}
                <div className="live-manager-layout-right-content">
                    {this.renderChatRecord(data)}
                    <div id="msg_end" />
                </div>
                {/*底部*/}
                <div className="live-manager-layout-right-footer">
                    {/*emoji表情 close={() => {this.emoji.close()}} */}
                    {
                        emoji && <React.Fragment>
                            <Emoji id="emoji" setvalue={(str) => { this.setState({ editorContent: str, emoji: !emoji }) }} />
                        </React.Fragment>
                    }
                    {/*工具栏*/}
                    <div className="live-manager-layout-right-footer-toolbar">
                        {/*上传图片*/}
                        {/* <div className="live-manager-layout-right-footer-toolbar-btn">
                                <span className="live-manager-layout-right-footer-toolbar-pic">
                                    <input type="file" accept="image/*" ref={this.imageRef} onChange={this.handleSubmitImage} />
                                </span>
                        </div> */}
                        {/*emoji表情包*/}
                        <div className="live-manager-layout-right-footer-toolbar-btn">
                            <span className="live-manager-layout-right-footer-toolbar-face" onClick={() => { this.setState({ emoji: !emoji }) }}>
                                {/*<input type="file" />*/}
                            </span>
                        </div>
                        {/*上传文件*/}
                        <div className="live-manager-layout-right-footer-toolbar-btn">
                            <span className="live-manager-layout-right-footer-toolbar-history">
                                <input type="file" ref={this.fileRef} onChange={this.handleSubmitFile} />
                            </span>
                        </div>
                        {/*/!*设置*!/*/}
                        {/*<div className="live-manager-layout-right-footer-toolbar-btn">*/}
                        {/*    <span className="live-manager-layout-right-footer-toolbar-set">*/}
                        {/*        <input type="file" />*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                    </div>
                    {/*输入框*/}
                    <div className="live-manager-layout-right-footer-editor">
                        <textarea id="discuss_textarea" value={editorContent} onChange={(e) => {
                            this.setState({
                                editorContent: e.target.value
                            })
                        }} />
                    </div>
                    {/*发送*/}
                    <div className="live-manager-layout-right-footer-submit">
                        <div className="live-manager-layout-right-footer-submit-btn" onClick={this.handleSubmitText}>
                            发送
                        </div>
                    </div>
                </div>
            </React.Fragment>)
        }


    }
}